module.exports = __webpack_public_path__ + "static/talk-7-67e2128c1586b3bd940bfca9437605e0.png";